import * as React from 'react';
import { FC } from 'react';

import { ISanityTextNode } from '@rbi-ctg/menu';

import { StyledText } from './loyalty-title-widget.styled';

interface ITitleWidgetProps {
  title: ISanityTextNode;
}

const LoyaltyTextWidget: FC<React.PropsWithChildren<ITitleWidgetProps>> = ({
  title,
}: ITitleWidgetProps) => {
  return <StyledText>{title.locale}</StyledText>;
};

export default LoyaltyTextWidget;
